exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.dialog-content .kye-dialog-body[data-v-38a1bc17] {\n  padding: 32px 16px;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-editor-new/components/super-link.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB","file":"super-link.vue","sourcesContent":["\n.dialog-content .kye-dialog-body[data-v-38a1bc17] {\n  padding: 32px 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a1bc17","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/kye-editor-new/components/super-link.vue
// module id = B9lK
// module chunks = 7